import styled from 'styled-components';
import { Dialog } from '@mui/material';

export const PreviewTriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  color: #0d4efe;
  background: rgba(13, 78, 254, 0.06);
  border: 1px solid rgba(13, 78, 254, 0.22);
  border-radius: 8px;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background: rgba(13, 78, 254, 0.1);
    border-color: rgba(13, 78, 254, 0.35);
  }

  &:focus-visible {
    outline: 2px solid rgba(13, 78, 254, 0.4);
    outline-offset: 2px;
  }
`;

export const PreviewDialog = styled(Dialog)`
  & .MuiDialog-paper {
    border-radius: 16px;
    max-width: 440px;
    width: 100%;
    border: 1px solid rgba(13, 78, 254, 0.12);
    box-shadow: 0 20px 48px rgba(13, 78, 254, 0.18);
  }
`;

export const PreviewDialogHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px 0 20px;
`;

export const PreviewDialogTitle = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1a1a2e;
`;

export const PreviewCardWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 4px 20px 24px;
  overflow: visible;

  & .MuiCard-root {
    cursor: default;
    overflow: visible;

    &:hover {
      transform: none;
      box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);
      border-color: rgba(0, 0, 0, 0.08);
    }
  }
`;

export const PreviewDialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 20px 16px;
`;
